import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { walletServices } from "../services/WalletService";
import { ReactComponent as UserGroupIcon } from "../icons/user-group.svg";
import { useNavigate } from 'react-router-dom';
import LoadingModal from "../components/LoadingModal";
import ConfirmationDialog from "../components/ConfirmationDialog";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import SearchBar from "../components/SearchBar";
import { formatCurrency } from "../tools/tool";
import { toast } from "react-toastify";
import { Button } from "bootstrap";
import { adminServices } from "../services/AdminServices";
import Dropdown from "../components/Dropdown";
import { use } from "react";
const PDLManagementPage = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [suspending, setSuspending] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [colonies, setColonies] = useState([]);
  const [colonyId, setColonyId] = useState(0);
  const handleSelectedRowsChange = ({
    selectedRows
  }) => {
    setSelectedRows(selectedRows);
  };
  useEffect(() => {
    if (!loaded) {
      getColonies();
      if (searchQuery === '') {
        // getPDLProfiles();
      } else {
        handleSearch();
      }
      setLoaded(true);
    } else {
      // Explicitly trigger on offset change, including offset === 0
      if (searchQuery === '') {
        getPDLProfiles();
      } else {
        handleSearch();
      }
    }
  }, [loaded, offset]);
  useEffect(() => {
    if (colonyId) {
      getPDLProfiles();
    }
  }, [colonyId]);
  const getColonies = () => {
    adminServices.storeProcedure2('getColonies', {}).then(r => {
      // expecting columns: colony_id, colony_name
      const data = r.data || [];
      const opts = data.map(c => ({
        value: c.colony_id,
        label: c.colony_name,
        fac: JSON.parse(c.facilities || [])
      }));
      var defaultOption = {
        label: 'All Colonies',
        value: 0
      };
      setColonies([defaultOption, ...opts]);
    }).catch(e => {
      //console.log('getColonies error', e);
    });
  };
  const Facility = fN => {
    let fac = "";
    switch (fN) {
      case "Q1":
        fac = "Quadrant 1";
        break;
      case "Q2":
        fac = "Quadrant 2";
        break;
      case "Q3":
        fac = "Quadrant 3";
        break;
      case "Q4":
        fac = "Quadrant 4";
    }
    return fac;
  };
  const getPDLProfiles = async () => {
    await walletServices.pdlList(limit, offset, colonyId).then(r => {
      setData(r.data.clients);
      setFilteredData(r.data.clients);
      setTotalRecords(r.data.totalRecord);
      toast.success(`PDL Profiles loaded successfully.`);
      var _col = [{
        name: 'ID',
        selector: data => data.id,
        sortable: true,
        width: "80px"
      }, {
        name: 'Last Name',
        selector: data => data.lastName,
        sortable: true
      }, {
        name: 'First Name',
        selector: data => data.firstName,
        sortable: true
      }, {
        name: 'Middle Name',
        selector: data => data.middleName,
        sortable: true
      }, {
        name: 'PDL Number',
        selector: data => data.pdlNumber,
        sortable: true
      }, {
        name: 'Gender',
        selector: data => data.gender == "M" ? "Male" : "Female",
        sortable: true
      }, {
        name: 'Facility Number',
        selector: data => data.facilityNumber,
        sortable: true
      }, {
        name: 'Wallet Balance',
        selector: data => formatCurrency(data.walletAmount),
        sortable: true
      }, {
        name: 'Action',
        selector: row => {
          return <a className="text-primary" onClick={() => handleSelectedRow(row)}>View</a>;
        },
        sortable: true
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(r => {
      if (r.status === 401) {
        window.location.href = "/";
      }
    });
  };
  const handleSelectedRow = row => {
    //console.log(row);
    localStorage.setItem('selectedPDL', btoa(JSON.stringify(row)));
    //window.location.href = "/pdl-transactions";
    navigate('/pdl-transactions');
  };
  const handleSearch = async () => {
    if (searchQuery === '') {
      setOffset(0);
      setSelectedRows([]);
      setFilteredData([]);
      await getPDLProfiles();
      return;
    }
    setLoading(true);
    await adminServices.getData('clients/search?query=' + searchQuery + `&offset=${offset}&limit=${limit}&colony=${colonyId}`).then(response => {
      if (response.status === 200) {
        setData(response.data.clients);
        setFilteredData(response.data.clients);
        setTotalRecords(response.data.totalRecord);
        setLoading(false);
      }
    });
  };
  return <div className="container">
    <ConfirmationDialog title={"Suspend PDLs"} show={showConfirm} message={"Are you sure you want to suspend the selected PDLs?"} onCancel={() => setShowConfirm(false)} onConfirm={async () => {
      setSuspending(true);
      setShowConfirm(false);
      setLoading(true);
      const selectedPDLs = selectedRows.map(row => row.id);
      await adminServices.storeProcedure2('suspend_pdls', {
        selected_pdl: selectedPDLs.join(',')
      }).then(response => {
        setLoading(false);
        setSuspending(false);
        toast.success(`PDLs suspended successfully.`, {
          autoClose: 3000,
          hideProgressBar: false,
          onClose: () => {
            window.location.reload();
          }
        });
      });
    }} />
    <LoadingModal show={loading} message={"Loading PDL Profiles..."} />
    <div className="sc-fPXMhL QAQQD" style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center'
    }}>
        <UserGroupIcon style={{
        width: "50px",
        height: "50px",
        marginRight: "10px"
      }} />
        PDL Profiles
    </div>


    
    <div className="row">
      <div className="col d-flex justify-content-start align-items-center">
        <input type="search" className="form-control-xs mr-1" style={{
          width: '350px'
        }} placeholder="Search PDL Profiles" onChange={e => {
          setSearchQuery(e.target.value.toLowerCase());
        }} />
        <button className="btn btn-secondary btn-xs" onClick={handleSearch}>
          <i className="fa fa-search"></i> Search
        </button>
      </div>
      <div className="col-auto">
        <button className="btn btn-xs" onClick={async () => {
          if (offset == 0) {
            return;
          }
          if (offset > 0) {
            setOffset(prev => prev - limit);
            setLoading(true);
            setFilteredData([]);
            return;
          }
        }}>
            <i className='fa fa-arrow-left'></i>
        </button>
        <span>
          Page {Math.floor(offset / limit) + 1} of {Math.ceil(totalRecords / limit)}
        </span>
        <button className="btn btn-xs" onClick={async () => {
          const newOffset = offset + limit;
          const totalPages = Math.ceil(totalRecords / limit);
          const currentPage = Math.floor(offset / limit) + 1;
          if (currentPage >= totalPages) {
            return;
          }
          setOffset(prev => prev + limit);
          setLoading(true);
          setFilteredData([]);
        }}>
            <i className='fa fa-arrow-right'></i>
        </button>
      </div>
    </div>
      <br />
      <div className="d-flex justify-content-start align-items-center mb-2">
          <Dropdown title={"Colony"} data={colonies} value={colonyId} onChange={val => {
        setColonyId(val.target.value);
      }} />
          {selectedRows.length > 0 && <div>
          <button type="button" className="btn btn-danger btn-xs" onClick={() => {
          setShowConfirm(true);
        }}>Suspend Selected PDLs</button>
        </div>}
      </div>
      
      <br />
      {!suspending && <DataTable columns={columns} data={filteredData} pagination={false} highlightOnHover pointerOnHover striped persistTableHead overflowX="scroll" selectableRows onSelectedRowsChange={handleSelectedRowsChange} />}
  </div>;
};
export default withAuthorization(PDLManagementPage, 2);